import { render, staticRenderFns } from "./NormalSearchNav451.vue?vue&type=template&id=b51c7284&scoped=true"
import script from "./NormalSearchNav451.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav451.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51c7284",
  null
  
)

export default component.exports